import React from 'react';
import Dropdown from './Dropdown';
import { YEARS } from '../data/constants';

const YearSelector = ({ selected, setSelected, label }) => (
  <Dropdown label={label} options={YEARS} value={selected} onChange={setSelected} />
);

export default YearSelector;
